import { map as rxjsmap } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ElectroControlScope, ElectroCourseOverview, ElectroEmergencyLightSystem, ElectroFireAlarmSystem, ElectroDistributionOverview, ElectroRiskAssessment, ElectroDocumentAssessment, ElectroFormTemplates } from '../models/electroinstallation';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ElectroInstallationService {


    constructor(private http: HttpClient) {
    }

    getEnabledForms(contractId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getenabledforms/' + contractId, ).pipe(rxjsmap((result: any) => result));
    }

    getContractBuildings(contractId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getcontractbuildings/' + contractId, ).pipe(rxjsmap((result: any) => result));
    }

    getInstallationFormsBuildingsTree(contractId: number){
        return this.http.get(environment.BASE_URL + '/electro/installation/getinstallationformsbuildingtree/' + BaseServices.BusinessId + '/' + contractId, ).pipe(rxjsmap((result: any) => result));
    }

    getControlScopeById(id: number){
        return this.http.get(environment.BASE_URL + '/electro/installation/getcontrolscope/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveControlScope(controlScope: ElectroControlScope) {
        return this.http.post(environment.BASE_URL + '/electro/installation/savecontrolscope', controlScope, ).pipe(rxjsmap((result: any) => result));
    }

    updateControlScope(controlScope: ElectroControlScope) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updatecontrolscope', controlScope, ).pipe(rxjsmap((result: any) => result));
    }
    getDocumentAssessmsentById(id: number){
        return this.http.get(environment.BASE_URL + '/electro/installation/getdocassessmentbyid/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveDocumentAssessmsent(DocumentAssessment: ElectroDocumentAssessment){
        return this.http.post(environment.BASE_URL + '/electro/installation/savedocumentassessment', DocumentAssessment, ).pipe(rxjsmap((result: any) => result));
    }

    updateDocumentAssessment(DocumentAssessment: ElectroDocumentAssessment){
        return this.http.put(environment.BASE_URL + '/electro/installation/updatedocumentassessment', DocumentAssessment, ).pipe(rxjsmap((result: any) => result));
    }

    getFirealarmSystemById(id: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getfirealarmsystem/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveFirealarmSystem(fireSystem: ElectroFireAlarmSystem) {
        return this.http.post(environment.BASE_URL + '/electro/installation/savefirealarmsystem', fireSystem, ).pipe(rxjsmap((result: any) => result));
    }

    updateFirealarmSystem(fireSystem: ElectroFireAlarmSystem) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updatefirealarmsystem', fireSystem, ).pipe(rxjsmap((result: any) => result));
    }

    getDistributionsById(id: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getdistributionoverviewbyid/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    getDistributionOverviewByBuilding(buildingId, inspectionId) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getdistributionoverviewbybuilding/'
        + buildingId + '/' + inspectionId, ).pipe(rxjsmap((result: any) => result));
    }

    saveDistributions(distribution: ElectroDistributionOverview) {
        return this.http.post(environment.BASE_URL + '/electro/installation/savedistributionoverview/', distribution, ).pipe(rxjsmap((result: any) => result));
    }

    updateDistributions(distribution: ElectroDistributionOverview) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updatedistributionoverview/', distribution, ).pipe(rxjsmap((result: any) => result));
    }

    createDistributionFromTemplate(buildingId, inspectionId) {
        return this.http.get(environment.BASE_URL + '/electro/installation/createdistributionfromtemplate/'
        + buildingId + '/' + inspectionId + '/' + BaseServices.UserId, ).pipe(rxjsmap((result: any) => result));
    }

    getCourseById(id: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getcourseoverviewbyid/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveCourse(course: ElectroCourseOverview) {
        return this.http.post(environment.BASE_URL + '/electro/installation/savecourseoverview/', course, ).pipe(rxjsmap((result: any) => result));
    }

    updateCourse(course: ElectroCourseOverview) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updatecourseoverview/', course, ).pipe(rxjsmap((result: any) => result));
    }

    getDistributionFloorByContract(contractId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getdistributionfloorbycontract/' + contractId, ).pipe(rxjsmap((result: any) => result));
    }

    getDistributionFloorByBuilding(buildingId: number, inspectionId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getdistributionfloorbybuilding/' + buildingId
        + '/' + inspectionId, ).pipe(rxjsmap((result: any) => result));
    }

    getEmergencyLightingById(id: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getemergenylightingbyid/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveEmergencyLighting(lighting: ElectroEmergencyLightSystem) {
        return this.http.post(environment.BASE_URL + '/electro/installation/saveemergencylighting/', lighting, ).pipe(rxjsmap((result: any) => result));
    }

    updateEmergencyLighting(lighting: ElectroEmergencyLightSystem) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updateemergencylighting/', lighting, ).pipe(rxjsmap((result: any) => result));
    }

    getRiskAssessmentById(id: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getriskassessment/' + id, ).pipe(rxjsmap((result: any) => result));
    }

    saveRiskAssessment(riskAssessment: ElectroRiskAssessment) {
        return this.http.post(environment.BASE_URL + '/electro/installation/saveriskassessment', riskAssessment, ).pipe(rxjsmap((result: any) => result));
    }

    updateRiskAssessment(riskAssessment: ElectroRiskAssessment) {
        return this.http.put(environment.BASE_URL + '/electro/installation/updateriskassessment', riskAssessment, ).pipe(rxjsmap((result: any) => result));
    }

    getEnabledFormsWithTemplate(contractId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/enabledformwithtemplate/' + contractId, ).pipe(rxjsmap((result: any) => result));
    }

    SaveTemplate(formTemplate: ElectroFormTemplates) {
        return this.http.post(environment.BASE_URL + '/electro/installation/saveformtemplate', formTemplate, ).pipe(rxjsmap((result: any) => result));
    }

    getContractFormTemplate(formType:number, contractId: number) {
        return this.http.get(environment.BASE_URL + '/electro/installation/getcontractformtemplate/'
        + formType +'/'+ contractId, ).pipe(rxjsmap((result: any) => result));
    }

    GetCourseFormTemplateByDistribution(contractId: number, distributionId: number){
        return this.http.get(environment.BASE_URL + `/electro/installation/getcourseformtemplatebydistribution/`
        + contractId + '/' + distributionId, ).pipe(rxjsmap((result: any) => result));
    }

    getCourseByInspectionDistribution(buildingId: number, inspectionId: number, distributionId: number){
        return this.http.get(environment.BASE_URL + `/electro/installation/getcoursebyinspectiondistribution/`
        + buildingId + '/' + inspectionId + '/' + distributionId, ).pipe(rxjsmap((result: any) => result));
    }

    getCoursesbyInspectionDistribution(buildingId: number, inspectionId: number, distributionId: number){
        return this.http.get(environment.BASE_URL + `/electro/installation/getcoursesbyinspectiondistribution/`
        + buildingId + '/' + inspectionId + '/' + distributionId, ).pipe(rxjsmap((result: any) => result));
    }
}
